// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.medicalCardForm_form_wrap__14JIN {
  text-align: center;
}
.medicalCardForm_form_wrap__14JIN form {
  width: 100%;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_disabled_form__EURjX {
  pointer-events: none;
  opacity: 0.9;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_field_group_wrap__ieprE {
  background: white;
  padding: 10px 16px;
  margin-top: 16px;
  border-radius: 8px;
  box-shadow: 0px 2px 6px 0.5px rgba(0, 0, 0, 0.1);
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_field_group_wrap__ieprE .medicalCardForm_field_group_title__YmzIj {
  font-size: 18px;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--primary-color);
  text-align: start;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_form_header__A7\\+tP {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_form_header__A7\\+tP .medicalCardForm_place_and_date_wrap__I1W0R {
  position: absolute;
  top: 10px;
  right: 16px;
  display: flex;
  gap: 8px;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_form_header__A7\\+tP .medicalCardForm_place_and_date_wrap__I1W0R .medicalCardForm_input_wrap__Moqjp {
  max-width: 160px;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_form_header__A7\\+tP .medicalCardForm_place_and_date_wrap__I1W0R .medicalCardForm_date_wrap__BKyY5 {
  display: flex;
  flex-direction: column;
  text-align: left;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_form_header__A7\\+tP .medicalCardForm_place_and_date_wrap__I1W0R .medicalCardForm_date_wrap__BKyY5 label {
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  padding-bottom: 4px;
  padding-left: 0;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_form_header__A7\\+tP .medicalCardForm_place_and_date_wrap__I1W0R .medicalCardForm_date_wrap__BKyY5 .datepicker_field {
  font-weight: 400;
  font-size: 16px;
  border: 1px solid var(--border-default-color);
  padding: 4px 8px;
  border-radius: 6px;
  width: 100%;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_form_header__A7\\+tP .medicalCardForm_place_and_date_wrap__I1W0R .medicalCardForm_date_wrap__BKyY5 .datepicker_field:focus {
  outline: var(--field-focus-color) 3px solid;
  border-color: #1f9d6d;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_form_header__A7\\+tP .medicalCardForm_place_and_date_wrap__I1W0R .medicalCardForm_date_wrap__BKyY5 .datepicker_field::placeholder {
  font-weight: 400;
  font-size: 14px;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_form_header__A7\\+tP .medicalCardForm_place_and_date_wrap__I1W0R label {
  font-weight: 500;
  font-size: 14px;
}
@media (max-width: 991px) {
  .medicalCardForm_form_wrap__14JIN .medicalCardForm_form_header__A7\\+tP .medicalCardForm_place_and_date_wrap__I1W0R {
    flex-direction: column;
  }
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_form_header__A7\\+tP .medicalCardForm_consultation_type_wrap__dNMvR img {
  width: 100px;
  height: 100px;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_form_header__A7\\+tP .medicalCardForm_consultation_type_wrap__dNMvR .medicalCardForm_input_wrap__Moqjp {
  align-items: center;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_form_header__A7\\+tP .medicalCardForm_consultation_type_wrap__dNMvR .medicalCardForm_input_wrap__Moqjp label {
  font-size: 14px;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_form_header__A7\\+tP .medicalCardForm_consultation_type_wrap__dNMvR .medicalCardForm_input_wrap__Moqjp .medicalCardForm_input_with_template__eXAG2 {
  display: flex;
  gap: 8px;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_form_header__A7\\+tP .medicalCardForm_consultation_type_wrap__dNMvR .medicalCardForm_input_wrap__Moqjp .medicalCardForm_input_with_template__eXAG2 input {
  min-width: 300px;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_form_header__A7\\+tP .medicalCardForm_consultation_type_wrap__dNMvR .medicalCardForm_input_wrap__Moqjp .medicalCardForm_input_with_template__eXAG2 button {
  flex-shrink: 0;
  font-size: 16px;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_field_group_title_wrap__F1iP3 {
  margin-bottom: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_field_group_title_wrap__F1iP3 label {
  margin-bottom: 0 !important;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_field_group_title_wrap__F1iP3 .medicalCardForm_badge__DaXUb {
  padding: 4px 8px;
  background-color: var(--main-bg-color);
  border: 1px solid var(--border-light-color);
  color: var(--gray-text-color);
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  flex-shrink: 0;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_field_group_title_wrap__F1iP3 .medicalCardForm_add_template_button__m0y1Z {
  margin-left: auto;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_user_data__Yj4tD {
  display: flex;
  gap: 24px;
  align-items: center;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_user_data__Yj4tD .medicalCardForm_data_item__SmiI8 {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  font-weight: 500;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_user_data__Yj4tD .medicalCardForm_data_item__SmiI8 .medicalCardForm_label__OU1Qe {
  color: var(--gray-text-color);
  text-transform: uppercase;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_user_data__Yj4tD .medicalCardForm_data_item__SmiI8 a {
  color: black;
  text-decoration: none;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_user_data__Yj4tD .medicalCardForm_data_item__SmiI8 a:hover {
  text-decoration: underline;
}
@media (max-width: 991px) {
  .medicalCardForm_form_wrap__14JIN .medicalCardForm_user_data__Yj4tD {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_field_wrap__9BDvf {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 8px;
  margin-top: 8px;
  text-align: left;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_field_wrap__9BDvf .medicalCardForm_field_item__cwUOH {
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_field_wrap__9BDvf span {
  margin-top: auto;
  color: var(--gray-text-color);
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_fields_grid_wrap__bgO8q {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 48px;
}
@media (max-width: 991px) {
  .medicalCardForm_form_wrap__14JIN .medicalCardForm_fields_grid_wrap__bgO8q {
    grid-template-columns: repeat(1, minmax(0, 1fr));
    gap: 0 24px;
  }
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_field_item_title__k8Dcc {
  font-weight: 500;
  text-transform: uppercase;
  font-size: 14px;
  width: 200px;
  flex-shrink: 0;
  padding-left: 0;
}
@media (max-width: 991px) {
  .medicalCardForm_form_wrap__14JIN .medicalCardForm_field_item_title__k8Dcc {
    font-size: 12px;
    width: 150px;
  }
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_strength_items_wrap__yveHc {
  display: flex;
  gap: 8px;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_strength_items_wrap__yveHc .medicalCardForm_strength_items__loSQu {
  display: flex;
  gap: 8px;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_strength_items_wrap__yveHc .medicalCardForm_strength_items__loSQu input {
  width: 60px;
}
@media (max-width: 991px) {
  .medicalCardForm_form_wrap__14JIN .medicalCardForm_strength_items_wrap__yveHc .medicalCardForm_strength_items__loSQu input {
    width: 45px;
  }
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_input_wrap__Moqjp {
  display: flex;
  flex-direction: column;
  text-align: left;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_input_wrap__Moqjp label {
  width: max-content;
  margin-bottom: 4px;
  font-weight: 500;
  font-size: 12px;
  padding: 0;
  text-transform: uppercase;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_input_wrap__Moqjp input,
.medicalCardForm_form_wrap__14JIN .medicalCardForm_input_wrap__Moqjp textarea {
  font-weight: 400;
  font-size: 16px;
  border: 1px solid var(--border-default-color);
  padding: 4px 8px;
  border-radius: 6px;
  width: 100%;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_input_wrap__Moqjp input:focus,
.medicalCardForm_form_wrap__14JIN .medicalCardForm_input_wrap__Moqjp textarea:focus {
  outline: var(--field-focus-color) 3px solid;
  border-color: #1f9d6d;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_input_wrap__Moqjp input::placeholder,
.medicalCardForm_form_wrap__14JIN .medicalCardForm_input_wrap__Moqjp textarea::placeholder {
  font-weight: 400;
  font-size: 14px;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_input_wrap__Moqjp textarea {
  min-height: 100px;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_input_preview_wrap__L2pZA {
  display: flex;
  align-items: center;
  margin-top: 16px;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_input_preview_wrap__L2pZA .medicalCardForm_input_file_wrap__Dy951 {
  display: flex;
  flex-direction: column;
  text-align: left;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_input_preview_wrap__L2pZA .medicalCardForm_input_file_wrap__Dy951 .medicalCardForm_hidden_file_input__FEsiH {
  display: none;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_input_preview_wrap__L2pZA .medicalCardForm_input_file_wrap__Dy951 .medicalCardForm_file_input_custom__IsX0Q {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 40px;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_input_preview_wrap__L2pZA .medicalCardForm_input_file_wrap__Dy951 .medicalCardForm_file_choose_button__-TZxd {
  border: none;
  background: #b0b3ba;
  border-radius: 12px;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  min-width: 100px;
  height: 100%;
  text-transform: uppercase;
  color: #000000;
  cursor: pointer;
  transition: background 0.2s ease-in-out;
  padding: 0 12px;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_input_preview_wrap__L2pZA .medicalCardForm_input_file_wrap__Dy951 .medicalCardForm_file_choose_button__-TZxd:hover {
  background: #818284;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_input_preview_wrap__L2pZA .medicalCardForm_input_file_wrap__Dy951 .medicalCardForm_file_name_label__9jkyK {
  font-size: 14px;
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_input_preview_wrap__L2pZA .medicalCardForm_preview__7zr8u {
  width: 100px;
  margin-left: 20px;
  cursor: pointer;
  position: relative;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_input_preview_wrap__L2pZA .medicalCardForm_preview__7zr8u img {
  width: 100%;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_input_preview_wrap__L2pZA .medicalCardForm_preview__7zr8u .medicalCardForm_delete_button__y\\+6am {
  position: absolute;
  top: -5px;
  right: -25px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 3px;
  transition: all 0.2s ease-in-out;
  width: 20px;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_input_preview_wrap__L2pZA .medicalCardForm_preview__7zr8u .medicalCardForm_delete_button__y\\+6am img {
  width: 100%;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_input_preview_wrap__L2pZA .medicalCardForm_preview__7zr8u .medicalCardForm_delete_button__y\\+6am:hover {
  transform: scale(0.93);
  transition: all 0.2s ease-in-out;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_input_preview_wrap__L2pZA .medicalCardForm_preview__7zr8u .medicalCardForm_delete_button__y\\+6am:active {
  transform: scale(0.9);
  transition: all 0.2s ease-in-out;
}
@media (max-width: 991px) {
  .medicalCardForm_form_wrap__14JIN .medicalCardForm_input_preview_wrap__L2pZA .medicalCardForm_preview__7zr8u .medicalCardForm_delete_button__y\\+6am {
    width: 15px;
  }
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_icd_badge_list_wrap__CWyDZ {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_icd_badge_list_wrap__CWyDZ .medicalCardForm_icd_badge_item__RPAD0 {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  background: var(--field-focus-color);
  border: 1px solid var(--border-light-color);
  border-radius: 25px;
  color: var(--primary-color);
  font-weight: 500;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_icd_badge_list_wrap__CWyDZ .medicalCardForm_icd_badge_item__RPAD0 span {
  color: var(--gray-text-color);
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_icd_badge_list_wrap__CWyDZ .medicalCardForm_icd_badge_item__RPAD0:hover {
  background: var(--primary-color-hover);
  border: 1px solid var(--primary-color-hover);
  cursor: pointer;
  color: white;
  transition: all 0.3s;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_icd_badge_list_wrap__CWyDZ .medicalCardForm_icd_badge_item__RPAD0:hover span {
  color: white;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_icd_list_wrap__2EI8i {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_icd_list_wrap__2EI8i .medicalCardForm_icd_item__Q91Nc {
  padding: 8px;
  border: 1px dashed var(--border-default-color);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: #fafbfd;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_icd_list_wrap__2EI8i .medicalCardForm_icd_item__Q91Nc .medicalCardForm_icd_item_header__ae1qx {
  display: flex;
  gap: 8px;
  align-items: center;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_icd_list_wrap__2EI8i .medicalCardForm_icd_item__Q91Nc span:first-of-type {
  font-weight: 500;
  color: var(--primary-color);
  flex-shrink: 0;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_icd_list_wrap__2EI8i .medicalCardForm_icd_item_icd_9__CBPoI {
  flex-direction: row;
  flex-wrap: wrap;
}
.medicalCardForm_form_wrap__14JIN .medicalCardForm_buttons_wrap__hqJUH {
  margin-top: 24px;
}

.medicalCardForm_modal_preview__Gw2Tz {
  width: 100%;
}
.medicalCardForm_modal_preview__Gw2Tz img {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Forms/MedicalCardForm/medicalCardForm.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AACE;EACE,WAAA;AACJ;AAEE;EACE,oBAAA;EACA,YAAA;AAAJ;AAGE;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gDAAA;AADJ;AAGI;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,2BAAA;EACA,iBAAA;AADN;AAKE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAHJ;AAKI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,QAAA;AAHN;AAKM;EACE,gBAAA;AAHR;AAMM;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AAJR;AAMQ;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AAJV;AAOQ;EACE,gBAAA;EACA,eAAA;EACA,6CAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AALV;AAOU;EACE,2CAAA;EACA,qBAAA;AALZ;AAQU;EACE,gBAAA;EACA,eAAA;AANZ;AAWM;EACE,gBAAA;EACA,eAAA;AATR;AAYM;EAjDF;IAkDI,sBAAA;EATN;AACF;AAaM;EACE,YAAA;EACA,aAAA;AAXR;AAcM;EACE,mBAAA;AAZR;AAcQ;EACE,eAAA;AAZV;AAeQ;EACE,aAAA;EACA,QAAA;AAbV;AAeU;EACE,gBAAA;AAbZ;AAgBU;EACE,cAAA;EACA,eAAA;AAdZ;AAqBE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AAnBJ;AAqBI;EACE,2BAAA;AAnBN;AAsBI;EACE,gBAAA;EACA,sCAAA;EACA,2CAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AApBN;AAuBI;EACE,iBAAA;AArBN;AAyBE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAvBJ;AAyBI;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;AAvBN;AAyBM;EACE,6BAAA;EACA,yBAAA;AAvBR;AA0BM;EACE,YAAA;EACA,qBAAA;AAxBR;AA0BQ;EACE,0BAAA;AAxBV;AA6BI;EA3BF;IA4BI,sBAAA;IACA,uBAAA;IACA,QAAA;EA1BJ;AACF;AA6BE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AA3BJ;AA6BI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AA3BN;AA8BI;EACE,gBAAA;EACA,6BAAA;AA5BN;AAgCE;EACE,aAAA;EACA,gDAAA;EACA,WAAA;AA9BJ;AAgCI;EALF;IAMI,gDAAA;IACA,WAAA;EA7BJ;AACF;AAgCE;EACE,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AA9BJ;AAgCI;EARF;IASI,eAAA;IACA,YAAA;EA7BJ;AACF;AAgCE;EACE,aAAA;EACA,QAAA;AA9BJ;AAgCI;EACE,aAAA;EACA,QAAA;AA9BN;AAgCM;EACE,WAAA;AA9BR;AAgCQ;EAHF;IAII,WAAA;EA7BR;AACF;AAkCE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AAhCJ;AAkCI;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;EACA,yBAAA;AAhCN;AAmCI;;EAEE,gBAAA;EACA,eAAA;EACA,6CAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AAjCN;AAmCM;;EACE,2CAAA;EACA,qBAAA;AAhCR;AAmCM;;EACE,gBAAA;EACA,eAAA;AAhCR;AAoCI;EACE,iBAAA;AAlCN;AAsCE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AApCJ;AAsCI;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AApCN;AAsCM;EACE,aAAA;AApCR;AAuCM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AArCR;AAwCM;EACE,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,uCAAA;EACA,eAAA;AAtCR;AAwCQ;EACE,mBAAA;AAtCV;AA0CM;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAxCR;AA4CI;EACE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AA1CN;AA2CM;EACE,WAAA;AAzCR;AA4CM;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,gCAAA;EACA,WAAA;AA1CR;AA4CQ;EACE,WAAA;AA1CV;AA6CQ;EACE,sBAAA;EACA,gCAAA;AA3CV;AA8CQ;EACE,qBAAA;EACA,gCAAA;AA5CV;AA+CQ;EAzBF;IA0BI,WAAA;EA5CR;AACF;AAiDE;EACE,aAAA;EACA,eAAA;EACA,QAAA;AA/CJ;AAiDI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,oCAAA;EACA,2CAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;AA/CN;AAiDM;EACE,6BAAA;AA/CR;AAkDM;EACE,sCAAA;EACA,4CAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;AAhDR;AAkDQ;EACE,YAAA;AAhDV;AAsDE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AApDJ;AAsDI;EACE,YAAA;EACA,8CAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AApDN;AAsDM;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AApDR;AAuDM;EACE,gBAAA;EACA,2BAAA;EACA,cAAA;AArDR;AAwDI;EACE,mBAAA;EACA,eAAA;AAtDN;AA0DE;EACE,gBAAA;AAxDJ;;AA2DA;EACE,WAAA;AAxDF;AAyDE;EACE,WAAA;AAvDJ","sourcesContent":[".form_wrap {\n  text-align: center;\n\n  form {\n    width: 100%;\n  }\n\n  .disabled_form {\n    pointer-events: none;\n    opacity: 0.9;\n  }\n\n  .field_group_wrap {\n    background: white;\n    padding: 10px 16px;\n    margin-top: 16px;\n    border-radius: 8px;\n    box-shadow: 0px 2px 6px 0.5px rgba(0, 0, 0, 0.1);\n\n    .field_group_title {\n      font-size: 18px;\n      font-weight: 600;\n      text-transform: uppercase;\n      color: var(--primary-color);\n      text-align: start;\n    }\n  }\n\n  .form_header {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    .place_and_date_wrap {\n      position: absolute;\n      top: 10px;\n      right: 16px;\n      display: flex;\n      gap: 8px;\n\n      .input_wrap {\n        max-width: 160px;\n      }\n\n      .date_wrap {\n        display: flex;\n        flex-direction: column;\n        text-align: left;\n\n        label {\n          font-size: 14px;\n          font-weight: 500;\n          text-transform: uppercase;\n          padding-bottom: 4px;\n          padding-left: 0;\n        }\n\n        :global(.datepicker_field) {\n          font-weight: 400;\n          font-size: 16px;\n          border: 1px solid var(--border-default-color);\n          padding: 4px 8px;\n          border-radius: 6px;\n          width: 100%;\n\n          &:focus {\n            outline: var(--field-focus-color) 3px solid;\n            border-color: #1f9d6d;\n          }\n\n          &::placeholder {\n            font-weight: 400;\n            font-size: 14px;\n          }\n        }\n      }\n\n      label {\n        font-weight: 500;\n        font-size: 14px;\n      }\n\n      @media (max-width: 991px) {\n        flex-direction: column;\n      }\n    }\n\n    .consultation_type_wrap {\n      img {\n        width: 100px;\n        height: 100px;\n      }\n\n      .input_wrap {\n        align-items: center;\n\n        label {\n          font-size: 14px;\n        }\n\n        .input_with_template {\n          display: flex;\n          gap: 8px;\n\n          input {\n            min-width: 300px;\n          }\n\n          button {\n            flex-shrink: 0;\n            font-size: 16px;\n          }\n        }\n      }\n    }\n  }\n\n  .field_group_title_wrap {\n    margin-bottom: 4px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 12px;\n\n    label {\n      margin-bottom: 0 !important;\n    }\n\n    .badge {\n      padding: 4px 8px;\n      background-color: var(--main-bg-color);\n      border: 1px solid var(--border-light-color);\n      color: var(--gray-text-color);\n      border-radius: 4px;\n      font-size: 14px;\n      font-weight: 500;\n      flex-shrink: 0;\n    }\n\n    .add_template_button {\n      margin-left: auto;\n    }\n  }\n\n  .user_data {\n    display: flex;\n    gap: 24px;\n    align-items: center;\n\n    .data_item {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 8px;\n      align-items: center;\n      font-weight: 500;\n\n      .label {\n        color: var(--gray-text-color);\n        text-transform: uppercase;\n      }\n\n      a {\n        color: black;\n        text-decoration: none;\n\n        &:hover {\n          text-decoration: underline;\n        }\n      }\n    }\n\n    @media (max-width: 991px) {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 8px;\n    }\n  }\n\n  .field_wrap {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding-bottom: 8px;\n    margin-top: 8px;\n    text-align: left;\n\n    .field_item {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n      text-align: left;\n    }\n\n    span {\n      margin-top: auto;\n      color: var(--gray-text-color);\n    }\n  }\n\n  .fields_grid_wrap {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 0 48px;\n\n    @media (max-width: 991px) {\n      grid-template-columns: repeat(1, minmax(0, 1fr));\n      gap: 0 24px;\n    }\n  }\n\n  .field_item_title {\n    font-weight: 500;\n    text-transform: uppercase;\n    font-size: 14px;\n    width: 200px;\n    flex-shrink: 0;\n    padding-left: 0;\n\n    @media (max-width: 991px) {\n      font-size: 12px;\n      width: 150px;\n    }\n  }\n\n  .strength_items_wrap {\n    display: flex;\n    gap: 8px;\n\n    .strength_items {\n      display: flex;\n      gap: 8px;\n\n      input {\n        width: 60px;\n\n        @media (max-width: 991px) {\n          width: 45px;\n        }\n      }\n    }\n  }\n\n  .input_wrap {\n    display: flex;\n    flex-direction: column;\n    text-align: left;\n\n    label {\n      width: max-content;\n      margin-bottom: 4px;\n      font-weight: 500;\n      font-size: 12px;\n      padding: 0;\n      text-transform: uppercase;\n    }\n\n    input,\n    textarea {\n      font-weight: 400;\n      font-size: 16px;\n      border: 1px solid var(--border-default-color);\n      padding: 4px 8px;\n      border-radius: 6px;\n      width: 100%;\n\n      &:focus {\n        outline: var(--field-focus-color) 3px solid;\n        border-color: #1f9d6d;\n      }\n\n      &::placeholder {\n        font-weight: 400;\n        font-size: 14px;\n      }\n    }\n\n    textarea {\n      min-height: 100px;\n    }\n  }\n\n  .input_preview_wrap {\n    display: flex;\n    align-items: center;\n    margin-top: 16px;\n\n    .input_file_wrap {\n      display: flex;\n      flex-direction: column;\n      text-align: left;\n\n      .hidden_file_input {\n        display: none;\n      }\n\n      .file_input_custom {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        height: 40px;\n      }\n\n      .file_choose_button {\n        border: none;\n        background: #b0b3ba;\n        border-radius: 12px;\n        font-weight: 600;\n        font-size: 12px;\n        line-height: 16px;\n        min-width: 100px;\n        height: 100%;\n        text-transform: uppercase;\n        color: #000000;\n        cursor: pointer;\n        transition: background 0.2s ease-in-out;\n        padding: 0 12px;\n\n        &:hover {\n          background: #818284;\n        }\n      }\n\n      .file_name_label {\n        font-size: 14px;\n        color: #6b7280;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        max-width: 200px;\n      }\n    }\n\n    .preview {\n      width: 100px;\n      margin-left: 20px;\n      cursor: pointer;\n      position: relative;\n      img {\n        width: 100%;\n      }\n\n      .delete_button {\n        position: absolute;\n        top: -5px;\n        right: -25px;\n        background-color: transparent;\n        border: none;\n        cursor: pointer;\n        padding: 3px;\n        transition: all 0.2s ease-in-out;\n        width: 20px;\n\n        img {\n          width: 100%;\n        }\n\n        &:hover {\n          transform: scale(0.93);\n          transition: all 0.2s ease-in-out;\n        }\n\n        &:active {\n          transform: scale(0.9);\n          transition: all 0.2s ease-in-out;\n        }\n\n        @media (max-width: 991px) {\n          width: 15px;\n        }\n      }\n    }\n  }\n\n  .icd_badge_list_wrap {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n\n    .icd_badge_item {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      padding: 4px 8px;\n      background: var(--field-focus-color);\n      border: 1px solid var(--border-light-color);\n      border-radius: 25px;\n      color: var(--primary-color);\n      font-weight: 500;\n\n      span {\n        color: var(--gray-text-color);\n      }\n\n      &:hover {\n        background: var(--primary-color-hover);\n        border: 1px solid var(--primary-color-hover);\n        cursor: pointer;\n        color: white;\n        transition: all 0.3s;\n\n        span {\n          color: white;\n        }\n      }\n    }\n  }\n\n  .icd_list_wrap {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-top: 16px;\n\n    .icd_item {\n      padding: 8px;\n      border: 1px dashed var(--border-default-color);\n      border-radius: 8px;\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n      background: #fafbfd;\n\n      .icd_item_header {\n        display: flex;\n        gap: 8px;\n        align-items: center;\n      }\n\n      span:first-of-type {\n        font-weight: 500;\n        color: var(--primary-color);\n        flex-shrink: 0;\n      }\n    }\n    .icd_item_icd_9 {\n      flex-direction: row;\n      flex-wrap: wrap;\n    }\n  }\n\n  .buttons_wrap {\n    margin-top: 24px;\n  }\n}\n.modal_preview {\n  width: 100%;\n  img {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form_wrap": `medicalCardForm_form_wrap__14JIN`,
	"disabled_form": `medicalCardForm_disabled_form__EURjX`,
	"field_group_wrap": `medicalCardForm_field_group_wrap__ieprE`,
	"field_group_title": `medicalCardForm_field_group_title__YmzIj`,
	"form_header": `medicalCardForm_form_header__A7+tP`,
	"place_and_date_wrap": `medicalCardForm_place_and_date_wrap__I1W0R`,
	"input_wrap": `medicalCardForm_input_wrap__Moqjp`,
	"date_wrap": `medicalCardForm_date_wrap__BKyY5`,
	"consultation_type_wrap": `medicalCardForm_consultation_type_wrap__dNMvR`,
	"input_with_template": `medicalCardForm_input_with_template__eXAG2`,
	"field_group_title_wrap": `medicalCardForm_field_group_title_wrap__F1iP3`,
	"badge": `medicalCardForm_badge__DaXUb`,
	"add_template_button": `medicalCardForm_add_template_button__m0y1Z`,
	"user_data": `medicalCardForm_user_data__Yj4tD`,
	"data_item": `medicalCardForm_data_item__SmiI8`,
	"label": `medicalCardForm_label__OU1Qe`,
	"field_wrap": `medicalCardForm_field_wrap__9BDvf`,
	"field_item": `medicalCardForm_field_item__cwUOH`,
	"fields_grid_wrap": `medicalCardForm_fields_grid_wrap__bgO8q`,
	"field_item_title": `medicalCardForm_field_item_title__k8Dcc`,
	"strength_items_wrap": `medicalCardForm_strength_items_wrap__yveHc`,
	"strength_items": `medicalCardForm_strength_items__loSQu`,
	"input_preview_wrap": `medicalCardForm_input_preview_wrap__L2pZA`,
	"input_file_wrap": `medicalCardForm_input_file_wrap__Dy951`,
	"hidden_file_input": `medicalCardForm_hidden_file_input__FEsiH`,
	"file_input_custom": `medicalCardForm_file_input_custom__IsX0Q`,
	"file_choose_button": `medicalCardForm_file_choose_button__-TZxd`,
	"file_name_label": `medicalCardForm_file_name_label__9jkyK`,
	"preview": `medicalCardForm_preview__7zr8u`,
	"delete_button": `medicalCardForm_delete_button__y+6am`,
	"icd_badge_list_wrap": `medicalCardForm_icd_badge_list_wrap__CWyDZ`,
	"icd_badge_item": `medicalCardForm_icd_badge_item__RPAD0`,
	"icd_list_wrap": `medicalCardForm_icd_list_wrap__2EI8i`,
	"icd_item": `medicalCardForm_icd_item__Q91Nc`,
	"icd_item_header": `medicalCardForm_icd_item_header__ae1qx`,
	"icd_item_icd_9": `medicalCardForm_icd_item_icd_9__CBPoI`,
	"buttons_wrap": `medicalCardForm_buttons_wrap__hqJUH`,
	"modal_preview": `medicalCardForm_modal_preview__Gw2Tz`
};
export default ___CSS_LOADER_EXPORT___;
